import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import About from '../views/About.vue'
import Courses from '../views/Courses.vue'
import Contact from '../views/Contact.vue'
import Faq from '@/views/Faq.vue'
import AdminLayout from '@/components/admin/Layout.vue'
import AdminLogin from '@/views/admin/Login.vue'
import AdminConfig from '@/views/admin/Config.vue'
import AdminTeachers from '@/views/admin/Teachers.vue'
import AdminCourses from '@/views/admin/AdminCourses.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/courses',
    name: 'Courses',
    component: Courses
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue')
      },
      {
        path: 'config',
        name: 'AdminConfig',
        component: AdminConfig
      },
      {
        path: '/admin/teachers',
        name: 'AdminTeachers',
        component: AdminTeachers
      }
      ,
      {
        path: '/admin/courses',
        name: 'AdminTeachers',
        component: AdminCourses
      }
    ]
  },
  {
    path: '/teacher/:id',
    name: 'TeacherDetail',
    component: () => import('@/views/TeacherDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAdminPage = to.path.startsWith('/admin')
  const isLoginPage = to.path === '/admin/login'
  const token = localStorage.getItem('token')

  if (isAdminPage && !isLoginPage && !token) {
    next('/admin/login')
  } else if (isLoginPage && token) {
    next('/admin/dashboard')
  } else {
    next()
  }
})

export default router 